import { Text, Button } from '@ui-component-library';

type SubscriptionSettingsProps = {
  userData?: Record<string, unknown>;
};

export default function SubscriptionSettings({ userData }: SubscriptionSettingsProps) {

  const isPlus = userData.is_plus || userData.subscription == "Treebula_Plus_year";

  return (
    <div className="w-full max-w-[700px] px-2 mx-auto">
      <section className="rounded-2xl bg-white-50 border-solid border-1 border-cloud-500 p-4">
        {/* Header */}
        <div className="p-6 border-b border-cloud-200 bg-cloud-50/30">
          <Text variant="text-base/leading-normal/medium" className="text-charcoal-1000">
            Dina prenumerationer
          </Text>
          <Text variant="text-sm/leading-normal/normal" className="text-charcoal-600">
            Hantera dina prenumerationer
          </Text>
        </div>

        {/* Subscription List */}
        <div className="divide-y divide-cloud-200">
          {/* Example: Treebula Plus */}
          <div className="p-6 flex flex-col lg:flex-row lg:items-center lg:justify-between hover:bg-cloud-50/50 transition-colors">
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <Text variant="text-sm/leading-normal/medium" className="text-charcoal-1000">
                  Treebula Plus
                </Text>
                {isPlus && (
                  <span className="px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-xs font-medium">
                    Aktiv
                  </span>
                )}
              </div>
              {userData.sub_start_time && <Text variant="text-xs/leading-normal/normal" className="text-charcoal-500">
                Från: {new Date(userData.sub_start_time as string).toLocaleDateString('sv-SE')}
              </Text>}
              {userData.sub_end_time && <Text variant="text-xs/leading-normal/normal" className="text-charcoal-500">
                Till: {new Date(userData.sub_end_time as string).toLocaleDateString('sv-SE')}
              </Text>}
              {!isPlus && <Text variant="text-xs/leading-normal/normal" className="text-charcoal-500">Ingen aktiv prenumeration</Text>}
            </div>

            <Button
              tw variant="primary"
              size="small"
              className="lg:mt-0 mt-2"
              onClick={() => { window.location.href = "/min-skog/?view=pricing"; }}
            >
              {isPlus ? 'Lägg till fler plus fastigheter' : 'Uppgradera'}
            </Button>

          </div>

          {/* Treebula Bas */}
          {!isPlus && <div className="p-6 flex items-center justify-between">
            <div className="flex flex-col gap-1">
              <Text variant="text-sm/leading-normal/medium" className="text-charcoal-1000">
                Treebula Bas
              </Text>
              <Text variant="text-xs/leading-normal/normal" className="text-charcoal-500">
                Ingår i ditt konto
              </Text>
            </div>
            <span className="text-xs text-charcoal-400 font-medium italic">Standard</span>
          </div>}
        </div>
      </section>
    </div>
  );
}
